import { render, staticRenderFns } from "./_resupplyEdit.tab.vue?vue&type=template&id=012a537d&scoped=true"
import script from "./_resupplyEdit.tab.vue?vue&type=script&lang=js"
export * from "./_resupplyEdit.tab.vue?vue&type=script&lang=js"
import style0 from "./_resupplyEdit.tab.vue?vue&type=style&index=0&id=012a537d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012a537d",
  null
  
)

export default component.exports